import React, { memo, useCallback } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { Form, Input, Col } from "antd";

// assets
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";

function PasswordField({
  data,
  index,
  method,
  // default
  className,
}) {
  const childClassNames = classNames(
    "custom-form-column",
    "password-input-column",
    className,
  );
  const { t } = useTranslation();

  const validatePassword = useCallback((rule, value, callback) => {
    if (value && value?.length > 0 && value?.length < 4) {
      return Promise.reject(t("inputs.minimumCharacters", { min: 4 }),);
    } else {
      return Promise.resolve();
    }
  }, []);

  // const isRequired =
  //   method !== undefined && method == 'update'
  //     ? false
  //     : data?.required || false;

  let newPassValidator = {};
  if (method == "new" || method == "new") {
    newPassValidator = {
      min: 6,
      validator: validatePassword,
      // validateTrigger: 'onSubmit',
    };
  }

  return (
    data && (
      <Col
        key={data?.name + index + "-col"}
        md={data?.col || 24}
        xs={24}
        offset={data?.offset || null}
        className={classNames(
          childClassNames,
          method !== undefined && method == "update" && "disabled-password",
        )}
      >
        <Form.Item
          key={data?.name + index + "-item"}
          label={data?.displayLabel ? data?.label : data?.label}
          name={data?.name}
          className={data?.name + "-wrapper password-input"}
          initialValue={data?.value || ""}
          rules={[
            {
              required: data?.required || false,
              message: t("inputs.mandatoryPassword"),
              //  validateTrigger: 'onSubmit',
            },
            {
              min: 6,
              message: t("inputs.minimumCharacters", { min: 6 }),
            },
            {
              pattern: /^(?=.*[A-Za-z\u00C0-\u017F])(?=.*\d).{6,}$/,
              message: t("inputs.atLeastOneNumberAndLetter"),
            },
            //newPassValidator,
          ]}
        >
          <Input.Password
            disabled={method !== undefined && method == "update"}
            placeholder={
              data?.placeholder !== undefined ? data?.placeholder : data?.label
            }
            iconRender={visible =>
              visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
            }
            autoComplete="new-password"
          />
        </Form.Item>
      </Col>
    )
  );
}

PasswordField.defaultProps = {
  method: "new",
  index: 1,
};

PasswordField.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.bool.isRequired,
    PropTypes.object.isRequired,
  ]),
};

export default memo(PasswordField);
